import { connect } from 'react-redux';
import { compose, hoistStatics, withProps } from 'recompose';
import { translate } from 'react-i18next';
import CustomColors from './CustomColors';
import { settingsActions } from '../../reducers/settings';

const mapStateToProps = state => ({
  customColors: state.settings.customColors,
  customCss: state.settings.customCss,
  customJs: state.settings.customJs,
  runCustomJs: state.settings.runCustomJs,
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withProps(props => {
    let { customJs, runCustomJs, updateSettings } = props;
    if (customJs && !runCustomJs) {
      updateSettings({ runCustomJs: true });
      try {
        const code = customJs;
        eval(code);
      } catch (error) {
        console.log(error);
      }
    }
    return { customJs };
  }),
);

export default hoistStatics(enhance)(CustomColors);



// WEBPACK FOOTER //
// ./src/components/customColors/index.js